import apiFetch from '../apiFetch'
export default function (token) {
  return apiFetch({ endPoint: 'TuneUpDestination', method: 'GET', body: null, token: token })
}
